import * as accountActions from './account'
import * as walldashActions from './walldash'
import * as dashboardActions from './dashboard'
import * as commonActions from './common'
import * as serviceGroupsActions from './service-groups'
import * as caseActions from './case'
import * as analyticsActions from './analytics'
import * as invoicesActions from './invoices'
import * as caseServiceLogActions from './case-service-log'
import * as devActions from './dev'
import * as caseAnomaliesActions from './case-anomalies'
import * as contractorsActions from './contractors'
import * as metadataActions from './metadata'
import * as clientActions from './client'
import * as referencesActions from './references'
import * as costCentersActions from './cost-centers'
import * as regionsActions from './regions'
import * as fetchDPUrlActions from "./fetchDPUrl"

export default {
  ...accountActions,
  ...walldashActions,
  ...dashboardActions,
  ...commonActions,
  ...serviceGroupsActions,
  ...analyticsActions,
  ...invoicesActions,
  ...caseActions,
  ...caseServiceLogActions,
  ...devActions,
  ...caseAnomaliesActions,
  ...contractorsActions,
  ...metadataActions,
  ...clientActions,
  ...referencesActions,
  ...costCentersActions,
  ...regionsActions,
  ...fetchDPUrlActions
}



// WEBPACK FOOTER //
// ./src/store/actions/index.js